/** TODO ↔ ラベル紐付けの取得・更新を提供するフック群 */

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "../lib/api";

const todoLabelsKey = (todoId: string) => ["todos", todoId, "labels"] as const;

/** TODO に紐付くラベルID一覧を取得する */
export const useTodoLabels = (todoId: string) => {
  return useQuery({
    queryKey: todoLabelsKey(todoId),
    queryFn: async (): Promise<string[]> => {
      const res = await api[":id"].labels.$get({ param: { id: todoId } });
      if (!res.ok) throw new Error("Failed to fetch todo labels");
      const json = await res.json();
      return json.data.labelIds;
    },
  });
};

export const useUpdateTodoLabels = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      todoId,
      labelIds,
    }: { todoId: string; labelIds: string[] }) => {
      const res = await api[":id"].labels.$put({
        param: { id: todoId },
        json: { labelIds },
      });
      if (!res.ok) throw new Error("Failed to update todo labels");
      const json = await res.json();
      return json.data;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["labels"] });
      queryClient.invalidateQueries({ queryKey: ["todos"] });
      queryClient.invalidateQueries({
        queryKey: todoLabelsKey(variables.todoId),
      });
    },
    onError: (err) => {
      toast.error("ラベルの紐付け更新に失敗しました");
    },
  });
};
